import axios from 'axios';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Setting, Subscription } from '../App';
import { CUSTOMER_API_URL } from '../constants';

export type Product = {
  productId: string;
  title: string;
  onlineStorePreviewUrl?: string;
  images: string[];
  isSetItem?: boolean;
  variants: {
    variantId: string;
    requiresShipping: boolean;
  }[];
};

export const useSubscriptionLineEditProduct = (setting: Setting) => {
  const [subscription, setSubscription] = useState<Subscription>();
  const [products, setProducts] = useState<Product[]>();
  const [page, setPage] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [infoMessage, setInfoMessage] = useState<string>('ローディング中...');
  const { id, lineId } = useParams<{ id: string; lineId: string }>();

  const [allProducts, setAllProducts] = useState<Product[]>();

  useEffect(() => {
    axios
      .post(
        `${CUSTOMER_API_URL}?action=getSubscription`,
        {
          subscriptionId: id,
        },
        {
          headers: { Authorization: setting.token },
        },
      )
      .then((response) => {
        console.log('response.data', response.data);
        setSubscription({ ...response.data, disabled: false });
      })
      .catch((e) => {
        console.log((e as Error).message);
      });
  }, []);

  useEffect(() => {
    if (!subscription) return;

    const decodedLineId = decodeURIComponent(lineId || '');
    let line = subscription.subscriptionLines.find((line) => line.lineId === decodedLineId);
    if (!line) {
      line = subscription.subscriptionLines[0];
    }

    axios
      .post(
        `${CUSTOMER_API_URL}?action=getAlternativeProducts`,
        {
          page,
          sellingPlanId: line.sellingPlanId,
        },
        {
          headers: { Authorization: setting.token },
        },
      )
      .then((response) => {
        console.log(response.data);
        setProducts(response.data.products);
        console.log('response.data.products', response.data.products);
        setHasNextPage(response.data.hasNextPage);

        if (response.data.products.length === 0) {
          setInfoMessage('この商品は変更できません。<br/>店舗にお問い合わせください。');
        }
      })
      .catch((e) => {
        console.log((e as Error).message);
        setInfoMessage('この商品は変更できません。<br/>店舗にお問い合わせください。');
      });

    // 全商品を取得
    // getAllProducts();
  }, [subscription]);

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight + 100; // buffer;

    setting.resize(height);
  }, [products, allProducts]);

  const paginate = (nextPage: number) => {
    if (!subscription) return;

    const decodedLineId = decodeURIComponent(lineId || '');
    let line = subscription.subscriptionLines.find((line) => line.lineId === decodedLineId);
    if (!line) {
      line = subscription.subscriptionLines[0];
    }

    setPage(nextPage);

    axios
      .post(
        `${CUSTOMER_API_URL}?action=getAlternativeProducts`,
        {
          page: nextPage,
          sellingPlanId: line.sellingPlanId,
        },
        {
          headers: { Authorization: setting.token },
        },
      )
      .then((response) => {
        setProducts(response.data.products);
        setHasNextPage(response.data.hasNextPage);
      })
      .catch((e) => {
        console.log((e as Error).message);
      });
  };

  const getAllProducts = async () => {
    if (!subscription) return;

    let line = subscription.subscriptionLines[0];
    let currentPage = 0;
    const new_products = [];

    // ページが存在する間、商品を取得
    while (true) {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=getAlternativeProducts`,
          {
            page: currentPage,
            sellingPlanId: line.sellingPlanId,
          },
          {
            headers: { Authorization: setting.token },
          },
        );

        // レスポンスから商品を取得
        new_products.push(...response.data.products);

        // allProductsを都度更新
        setAllProducts(new_products);

        // 次のページが存在しない場合、ループを終了
        if (response.data.hasNextPage === false) {
          break;
        }

        currentPage++;
      } catch (e) {
        console.log((e as Error).message);
        break;
      }
    }
  };

  return {
    subscription,
    products,
    lineId,
    infoMessage,
    page,
    hasNextPage,
    paginate,
    allProducts,
    setAllProducts,
  };
};
